import React from "react";
import { Collapse, Grid, Typography, Link } from '@material-ui/core';
import classnames from 'classnames';
import { makeStyles } from "@material-ui/core/styles";
import { getTimeUpLoad, isVideo, isImage } from '../utils';
import { baseAuthUrl } from '../authProvider';
import { useTranslate, } from 'react-admin';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        marginTop: theme.spacing(1),
        flexGrow: 12
    },

    childItem: {
        marginLeft: 8,
        marginRight: 8,
        color: theme.palette.text.secondary,
        display: 'flex',
        alignItems: 'center',
    },
    childItemSelected: {
        color: 'white',
    },
    subtitle: {
        fontSize: 11
    },
    item: {
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 12,
    },
    image: {
        width: 'auto',
        maxWidth: 295,
        maxHeight: 216,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 12,
        paddingBottom: 12,
    },
    video: {
        paddingLeft: 10,
        width: 295,
        height: 216
    },
    title: {
        paddingTop: 22,
        paddingBottom: 26

    },
    titlename: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
    },
    titlestyle: {
        fontFamily: "UniviaPro",
        fontSize: "8px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: " 0.08px",
    },
    padding: {
        paddingBottom: 26,
    },
    textValue: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: "0.13px",
        color: '#4f5064'
    }
}));

function Preview({ filetype, filePath, expand }) {
    const classes = useStyles();

    if (isImage(filetype)) {
        return (
            expand === true &&
            <img alt='' className={classnames(classes.image)} src={filePath} />
        );
    } else if (isVideo(filetype)) {
        return (
            expand === true &&
            <video muted controls preload="auto" className={classnames(classes.video)} >
                <source src={filePath}></source>
            </video>
        );
    } else {
        // Audio
        return (
            expand === true &&
            <video controls preload="auto" className={classnames(classes.video)} >
                <source src={filePath}></source>
            </video>
        );
    }
}

export default function CollapseImage({ expand, item }) {
    const translate = useTranslate();
    const classes = useStyles();

    const { fd, createdAt, size, name, owner, type, dimension } = item;
    const filePath = `${baseAuthUrl}/media/${fd}`;
    return (
        <Collapse in={expand}>
            <div className={classes.item} >
                <Grid container>
                    <Grid sm={5} md={5} lg={5} item>
                        <Preview expand={expand} filetype={type} filePath={filePath} />
                    </Grid>
                    <Grid sm={7} md={7} lg={7} item>
                        <div className={classes.title}>
                            <Typography className={classes.titlename}>{name}</Typography>
                        </div>
                        <div className={classnames(classes.subtitle, classes.childItem)} style={{ flex: 1 }}>
                            <Typography className={classes.titlestyle}>{translate('pos.categories.url')}</Typography>
                        </div>
                        <div className={classnames(classes.childItem, classes.body, classes.padding)} style={{ flex: 1 }}>
                            <Link href={filePath} target='_blank'>
                                <Typography className={classes.textValue}>{filePath}</Typography>
                            </Link>
                        </div>
                        <div className={classnames(classes.childItem, classes.padding)} style={{ flex: 1 }}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography className={classes.titlestyle}>{translate('pos.categories.filesize')}</Typography>
                                    <div >
                                        <Typography className={classes.textValue}>{Math.ceil(size / 1000000)} {translate('pos.common.mb')}</Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className={classes.titlestyle}>{translate('pos.categories.pixel')}</Typography>
                                    <div >
                                        <Typography className={classes.textValue}>{dimension}</Typography>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className={classnames(classes.childItem, classes.padding)} style={{ flex: 1 }}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography className={classes.titlestyle}>{translate('pos.categories.uploaded')}</Typography>
                                    <div >
                                        <Typography className={classes.textValue}>{getTimeUpLoad(createdAt)}</Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className={classes.titlestyle}>{translate('pos.categories.uploadedBy')}</Typography>
                                    <div >
                                        <Typography className={classes.textValue}>{owner}</Typography>
                                    </div>

                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div >
        </Collapse >
    );
}

CollapseImage.propTypes = {
    expand: PropTypes.bool.isRequired,
    item: PropTypes.object.isRequired,
};
